import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import React from "react";
import { signOut } from "./App";

const DisabledError = () => {
  return (
    <div className="error-page">
      <Tooltip title="Cerrar sesión">
        <IconButton className="logout-button" onClick={signOut}>
          <PowerSettingsNewIcon fontSize="large" />
        </IconButton>
      </Tooltip>
      <img src={`${process.env.PUBLIC_URL}/assets/images/loading-logo.png`} alt="logo" />
      <div className="title">
        <Typography className="text" component="span">
          Tu usuario o tienda se encuentra deshabilitad@
        </Typography>
        <span className="emoji" role="img" aria-label="emoticon">
          😕
        </span>
      </div>
      <Typography className="mail" align="center" gutterBottom>
        Favor escríbenos a <Link href="mailto:hola@carritofacil.cl">hola@carritofacil.cl</Link>
      </Typography>
    </div>
  );
};

export default DisabledError;
